import updateObject from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import { initialGdprErasureLogTable } from "./helper";

const initialState = {
    gdprErasureLogTable: initialGdprErasureLogTable,
};

const mergeTable = (state, patch) =>
    updateObject(state, { gdprErasureLogTable: updateObject(state.gdprErasureLogTable, patch) });

const gdprErasureLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_GDPR_ERASURE_LOG_LOADING:
            return mergeTable(state, { loading: action.value });

        case actionTypes.SET_GDPR_ERASURE_LOG_PAGE_DATA: {
            const payload = action.payload ?? {};
            return mergeTable(state, {
                items: payload.items ?? [],
                totalElements: payload.totalElements ?? 0,
                page: payload.page ?? 0,
                size: payload.size ?? state.gdprErasureLogTable.size,
            });
        }

        case actionTypes.SET_GDPR_ERASURE_LOG_FILTERS:
            return mergeTable(state, { filters: action.filters, page: 0 });

        case actionTypes.SET_GDPR_ERASURE_LOG_PAGE:
            return mergeTable(state, { page: action.page });

        case actionTypes.SET_GDPR_ERASURE_LOG_SIZE:
            return mergeTable(state, { size: action.size, page: 0 });

        default:
            return state;
    }
};

export default gdprErasureLogReducer;
